import { Carousel } from 'primereact/carousel';
import React, {
    useEffect, //, useRef
    useState,
} from 'react';
import { Avatar } from 'primereact/avatar';
import { useSelector } from 'react-redux';
import './shoutOutCarousel.scss';
import { Badge } from 'primereact/badge';
import { Tooltip } from 'primereact/tooltip';
import { Divider } from 'primereact/divider';
import { selectCurrentEmpid } from '../../../../pages/login/authSlice';
import HappyIcon from '../../../../assets/happy1.svg';
import ClapIcon from '../../../../assets/clap.svg';
import AwesomeIcon from '../../../../assets/awesome.svg';
import LikeIcon from '../../../../assets/like.svg';
import HeartIcon from '../../../../assets/heart.svg';
import commentIcon from '../../../../assets/Comment.svg';
// import SendIcon from '../../../../assets/Send.svg';
import SadIcon from '../../../../assets/Sad.svg';
import { formatDate3 } from '../../../../utils/dateFormat';
import MedalIcon from '../../../../assets/medal2.png';
import { CoachingShoutoutAttentionDia } from '../../../../components/coachingShoutoutAttentionDia/CoachingShoutoutAttentionDia';

const icons: { [key: string]: string } = {
    like: LikeIcon,
    clap: ClapIcon,
    love: HeartIcon,
    surprised: AwesomeIcon,
    laugh: HappyIcon,
    sad: SadIcon,
};
interface ShoutOutCarouselProps {
    shoutOuts: any[];
    via?: string;
}

export const ShoutOutCarousel = ({ shoutOuts, via }: ShoutOutCarouselProps) => {
    const itemTemplate = (shoutOut: any) => {
        const [showComments, setShowComments] = useState<boolean>(false);
        const [reactionCounts, setReactionCounts] = useState([]);
        const [currentUserReacted, setCurrentUserReacted] = useState(false);
        const currentEmpid = useSelector(selectCurrentEmpid);
        const [height, setHeight] = useState(0);
        const [awardcoURL, setAwardcoURL] = useState<string>('');
        const [newComments, setNewComments] = useState<boolean>(false);

        useEffect(() => {
            const uniqueReactions = Array.from(
                new Set(shoutOut?.reactions?.map((item: any) => item.reaction_type))
            );
            const hasUserReacted = shoutOut?.reactions?.some(
                (reaction: any) => reaction.employee_number === currentEmpid
            );
            setCurrentUserReacted(hasUserReacted);
            const reactionCountsMap: any = [];
            uniqueReactions.forEach((reactionTypeName: any) => {
                const Reactions = shoutOut?.reactions?.filter(
                    (reaction: any) => reaction.reaction_type === reactionTypeName
                );
                const reaction = {
                    reactionType: reactionTypeName,
                    icon: icons[reactionTypeName],
                    count: Reactions?.length,
                    members: Array.from(new Set(Reactions.map((item: any) => item.reaction_created_by))),
                };
                reactionCountsMap.push(reaction);
            });
            setReactionCounts(reactionCountsMap);
            const commentsHeight = height <= 0 ? (shoutOut?.comments?.length || 0) * 90 : height;
            setHeight(commentsHeight);
        }, [shoutOut]);

        const getReactionAuthors = (authors: any) => {
            return authors.length > 0
                ? `${authors.map((name: any) => ` ${name}`).join('\n')}`
                : 'No reactions yet';
        };

        return (
            <div className="shoutOutCarouselGrid">
                <div
                    className={
                        via === 'agent_landingpage'
                            ? 'BadgeIcon shoutOutCarouselImage'
                            : 'shoutOutCarouselIconSVG shoutOutCarouselImage'
                    }
                />
                <div className="shoutOutCarouselTitle">
                    <span
                        className={via === 'agent_landingpage' ? 'Font-16' : 'Font-30'}
                        style={{ marginTop: '10px', marginRight: '13px', display: 'inline-flex' }}
                    >
                        {shoutOut?.recipient}
                    </span>
                    <br />
                    {via !== 'agent_landingpage' && <br />}
                    <span className={via === 'agent_landingpage' ? 'SmallBadgeText' : 'LargeBadgeText'}>
                        <img
                            src={MedalIcon}
                            alt=""
                            className={via === 'agent_landingpage' ? 'SmallMedalIcon' : 'LargeMedalIcon'}
                        />
                        {shoutOut?.shout_out_title}
                    </span>

                </div>
                <div className="shoutOutCarouselName">
                    <div className="row">
                        <div className="col-md-11" style={{ textAlign: 'justify' }}>
                            <p
                                className={
                                    via === 'agent_landingpage'
                                        ? 'SmallDescriptionText'
                                        : 'LargeDescriptionText'
                                }
                            >
                                {shoutOut?.shout_out_description}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 float-end d-flex align-items-center justify-content-end">
                            <Avatar
                                label={shoutOut?.author_short_name}
                                shape="circle"
                                className={
                                    via === 'agent_landingpage' ? 'SmallAvatarIcon' : 'LargeAvatarIcon'
                                }
                            />
                            <span
                                className={
                                    via === 'agent_landingpage' ? 'SmallAuthorName' : 'LargeAuthorName'
                                }
                            >
                                {shoutOut?.author}
                            </span>
                        </div>
                    </div>
                    <Divider />
                    <div className="row">
                        <div className="col-md-6" />
                        <div className="col-md-6" style={{ paddingRight: '25px' }}>
                            {reactionCounts.map((reaction: any) => (
                                <i key={reaction.reactionType} className="p-overlay-badge">
                                    <img
                                        className="reactionImage"
                                        src={icons[reaction.reactionType.toLowerCase()]}
                                        alt={reaction.reactionType}
                                    />
                                    <Badge
                                        value={reaction.count}
                                        className={`${'tooltip'}${reaction.reactionType}`}
                                    />
                                    <Tooltip
                                        mouseTrack
                                        mouseTrackLeft={10}
                                        target={`${'.tooltip'}${reaction.reactionType}`}
                                        content={getReactionAuthors(reaction.members)}
                                        style={{ fontSize: '14px' }}
                                    />
                                </i>
                            ))}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            {shoutOut?.comments && shoutOut?.comments?.length > 0 && (
                                <button
                                    title="Comments"
                                    style={{ textAlign: 'left' }}
                                    onClick={() => {
                                        setShowComments(!showComments);
                                    }}
                                    className="commentsButton flex items-center space-x-2 px-4 py-2 rounded-md"
                                >
                                    {showComments ? 'Hide comments' : 'Show comments'}
                                    <i
                                        style={{ marginLeft: '5px', verticalAlign: 'middle' }}
                                        className={showComments ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
                                    />
                                </button>
                            )}
                        </div>

                        <div
                            className="col-md-4 mt-10 float-end"
                            style={{ display: 'flex', float: 'right', justifyContent: 'flex-end' }}
                        >
                            <button
                                title="Comments"
                                style={{ marginTop: '5px' }}
                                onClick={() => {
                                    setAwardcoURL(shoutOut?.external_shout_out_url);
                                    setNewComments(true);
                                }}
                                className="emoji"
                            >
                                <img
                                    src={commentIcon}
                                    alt="Comment"
                                    style={{ height: via === 'agent_landingpage' ? '22px' : '28px' }}
                                />
                            </button>
                            <button
                                title="Reactions"
                                onClick={() => {
                                    setAwardcoURL(shoutOut?.external_shout_out_url);
                                    setNewComments(true);
                                }}
                                className="emoji"
                            >
                                <i
                                    className="pi pi-thumbs-up"
                                    style={{
                                        fontSize: via === 'agent_landingpage' ? '20px' : '25px',
                                        color: currentUserReacted ? '#2196F3' : 'black',
                                    }}
                                />
                            </button>
                            {/* <OverlayPanel ref={op} style={{ transform: 'translateY(-100px)' }}>
                                <button
                                    title='Like' onClick={() => { handlecreateShoutoutReaction('Like'); }}
                                    className="emoji"
                                >
                                    <img src={LikeIcon} alt="Like" style={{ height: '46px' }} />
                                </button>
                                <button
                                    title='Love' onClick={() => { handlecreateShoutoutReaction('Love'); }}
                                    className="emoji"
                                >
                                    <img src={HeartIcon} alt="Love" />
                                </button>
                                <button
                                    title='Laugh' onClick={() => { handlecreateShoutoutReaction('Laugh'); }}
                                    className="emoji"
                                >
                                    <img src={HappyIcon} alt="Laugh" />
                                </button>
                                <button
                                    title='Surprised' onClick={() => { handlecreateShoutoutReaction('Surprised'); }}
                                    className="emoji"
                                >
                                    <img src={AwesomeIcon} alt="Surprised" />
                                </button>
                                <button
                                    title='Clap' onClick={() => { handlecreateShoutoutReaction('Clap'); }}
                                    className="emoji"
                                >
                                    <img src={ClapIcon} alt="Clap" />
                                </button>
                                <button
                                    title='Sad' onClick={() => { handlecreateShoutoutReaction('Sad'); }}
                                    className="emoji"
                                >
                                    <img src={SadIcon} alt="Sad" />
                                </button>
                            </OverlayPanel> */}
                        </div>

                        {showComments && (
                            <div
                                className="hideDisplay mt-4 p-4 bg-gray-100 rounded-lg textalign"
                                style={{ borderTop: '1px solid lightgray' }}
                            >
                                <div className="shoutOutCommentsSection row">
                                    <div
                                        className="row CommentsDiv"
                                        style={{
                                            marginTop: '20px',
                                            display: 'inline',
                                            height: `${height}px`,
                                            maxHeight: '350px',
                                            overflow: 'auto',
                                        }}
                                    >
                                        {shoutOut?.comments?.map((comment: any, index: number) => (
                                            <div key={index} className="p-2">
                                                <div className="row">
                                                    <div
                                                        className={
                                                            via === 'agent_landingpage'
                                                                ? 'col-md-2'
                                                                : 'col-md-1'
                                                        }
                                                    >
                                                        <Avatar
                                                            label={comment.comment_created_by_short}
                                                            style={{
                                                                backgroundColor: '#2196F3',
                                                                color: '#ffffff',
                                                                borderRadius: '25px',
                                                                verticalAlign: 'sub',
                                                            }}
                                                            shape="circle"
                                                        />
                                                    </div>

                                                    <div
                                                        className={
                                                            via === 'agent_landingpage'
                                                                ? 'col-md-10'
                                                                : 'col-md-11'
                                                        }
                                                    >
                                                        <div className="d-flex" style={{ textAlign: 'left' }}>
                                                            <p>
                                                                <strong>{comment.comment_created_by}</strong>
                                                                <span className="text-muted ms-2">
                                                                    {' '}
                                                                    |{' '}
                                                                    {formatDate3(
                                                                        new Date(comment.comment_date)
                                                                    )}
                                                                </span>
                                                            </p>
                                                        </div>
                                                        <p
                                                            className="mb-1"
                                                            style={{ float: 'left', fontWeight: '100' }}
                                                        >
                                                            {comment.comment_text}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <CoachingShoutoutAttentionDia
                    visible={newComments}
                    onHide={() => setNewComments(false)}
                    onContinue={() => {
                        if (awardcoURL) window.open(awardcoURL, '_blank');
                        else window.open('https://ttec.awardco.com/', '_blank');
                    }}
                />
            </div>
        );
    };
    return shoutOuts.length > 0 || via === 'agent_landingpage' ? (
        <div
            className="card shoutout-carousel-card"
            style={{ maxWidth: '100%', height: '100%', padding: '2px' }}
        >
            {via === 'agent_landingpage' && (
                <h4
                    className="shoutout-carousel-title"
                    style={{ textAlign: 'left', color: 'white', margin: '20px 10px 0px 20px' }}
                >
                    Shout Outs
                </h4>
            )}
            {shoutOuts.length > 0 ? (
                <Carousel
                    id="shoutoutCarousel"
                    value={shoutOuts}
                    numVisible={1}
                    numScroll={1}
                    itemTemplate={itemTemplate}
                />
            ) : (
                <h4 style={{ height: '100%', padding: '100px', color: '#FFFFFF', textAlign: 'center' }}>
                    No Data <br />
                    Available
                </h4>
            )}
        </div>
    ) : null;
};
